import { useEffect, useRef, useState } from "react";

/**
 * Masked slide-up text reveal, triggered when scrolled into view.
 * Children should be a string. Wraps the content in a clipped span and
 * eases via cubic-bezier(0.2, 0.85, 0.2, 1).
 */
export const RevealText = ({
  children,
  className = "",
  delay = 0,
  duration = 1000,
  as: Tag = "span",
  threshold = 0.2,
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold, rootMargin: "0px 0px -10% 0px" }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);

  return (
    <Tag ref={ref} className={`reveal-line ${className}`}>
      <span
        className="reveal-line-inner"
        style={{
          transitionDelay: `${delay}ms`,
          transitionDuration: `${duration}ms`,
          transform: visible ? "translate3d(0,0,0)" : "translate3d(0,110%,0)",
          opacity: visible ? 1 : 0,
        }}
      >
        {children}
      </span>
    </Tag>
  );
};
